import { EventEmitter, Injectable, Output } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { APIServiceProvider } from "../common/services/api.service";
import { ManagerPage } from "../pages/manager/manager";

export interface MenuItem {
	title: string;
	component: any;
	icon: string;
}

@Injectable()
export class UserService {
	@Output()
	userStatusChanged = new EventEmitter();

	appMenuItems: Array<MenuItem>;

	constructor(
		public http: HttpClient,
		public apiService: APIServiceProvider
	) {}

	checkForSubordinates() {
		let self = this;

		if (!localStorage.getItem("gp_token")) {
			return false;
		}

		let postData: any = {};
		postData.manager_id = localStorage.getItem("user-id");

		self.apiService
			.post("orders/check-subordinates", postData)
			.subscribe(result => {
				if (result["data"] !== 0) {
					let managerViewMenu: any = {
						title: "My Team",
						component: ManagerPage,
						icon: "people"
					};

					var Index = this.getTheArrIndex(
						this.appMenuItems,
						"My Team"
					);

					if (Index === null) {
						this.appMenuItems.push(managerViewMenu);
					}
				}
			});
	}

	getTheArrIndex(data, title) {
		if (data.length === 0) {
			return null;
		}
		var keepGoing = true;
		var keyVal = null;

		for (var i = 0; i < data.length; i++) {
			if (keepGoing) {
				if (data[i].title === title) {
					keyVal = i;
					keepGoing = false;
				}
			}
		}

		return keyVal;
	}
}



// WEBPACK FOOTER //
// ./src/services/user.service.ts